
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/D2C-POS-Solutions",
      function () {
        return require("private-next-pages/D2C-POS-Solutions.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/D2C-POS-Solutions"])
      });
    }
  